import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import Autosuggest from 'react-autosuggest';
import './autosuggest.css';
import PropTypes from 'prop-types';
import $, { param } from 'jquery';

export class Banner extends Component {

    static propTypes = {
        pageData: PropTypes.object,
        onChange: PropTypes.func

    };

    constructor(props) {
        super(props);
        this.state = {
            data: {}
        };
       // this.populateActiveSponser();

    }

    componentDidMount() {
        console.log("Banner loading");
        this.populateActiveSponser();
        
    }

    async populateActiveSponser() {
        const response = await fetch('v1/api/sponsers', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        this.setState({ data: data.data, loading: false });

        if (data != null && data.status) {
            
            this.props.onChange(data.data[0].id);
        }
    }


    render() {

        if (this.state.data != null && this.state.data.length > 0) {
            return (
                <>
                    <section id="banner">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">
                                    <img src={this.state.data[0].bannerImage} alt="" />
                                </div>
                            </div>
                        </div>
                        <img src="images/element_shape-1.png" class="element-3" alt="" />
                    </section>


                </>
            );
        } else {

            return (<>
                Loading..
            </>);
        }
  }
}
